import React from "react";
import { Shell } from "@/components/loomi/Layout";
import { ADMIN_NAV } from "./AdminDashboard";
import TwoFactorPanel from "@/components/loomi/TwoFactorPanel";

export default function AdminSettings() {
  return (
    <Shell title="Settings" portalLabel="Admin" nav={ADMIN_NAV}>
      <TwoFactorPanel testId="admin-twofa-panel" />
    </Shell>
  );
}
